import { useEffect, useState } from 'react';
import { Link, useParams, useSearchParams } from 'react-router-dom';
import { t } from '../lib/i18n';
import { startSso } from '../settings/sso-api';
import { AuthLayout } from './AuthLayout';

/**
 * The stable per-connection sign-in link (Phase 65).
 *
 * A company puts this URL in their intranet, or their provider uses it as the "sign in from the
 * application" entry point, and it does one thing: ask the API where to send the browser.
 *
 * The authorization URL is built by the server, never here — it carries a `state` and a `nonce` the
 * server has to remember, and a front-end that invented either would be inventing the security of
 * the whole flow.
 */
export function SsoStartPage(): React.JSX.Element {
  const { connectionId = '' } = useParams();
  const [params] = useSearchParams();
  const [error, setError] = useState<string | null>(null);

  const returnTo = params.get('proximo');

  useEffect(() => {
    let cancelled = false;

    startSso(connectionId, returnTo ?? undefined)
      .then((started) => {
        if (!cancelled) window.location.assign(started.authorization_url);
      })
      .catch(() => {
        if (!cancelled) setError(t('sso.startFailed'));
      });

    return () => {
      cancelled = true;
    };
  }, [connectionId, returnTo]);

  return (
    <AuthLayout>
      <header className="auth__heading">
        <h1>{t('sso.redirecting')}</h1>
        <p>{error ?? t('sso.redirectingBody')}</p>
      </header>

      {error && (
        <p className="auth__switch">
          <Link to="/entrar">{t('sso.backToSignIn')}</Link>
        </p>
      )}
    </AuthLayout>
  );
}
